:host {
  display: block;
}

.spw-header-lang-item {
  transition: background 0.3s;

  @include under-breakpoint(lg) {
    margin-right: 24px;
  }

  &:hover {
    @include breakpoint(lg) {
      background: var(--spw-color-themes-grey-grey-200);
    }
  }

  ::slotted(a) {
    text-decoration: underline !important;
    color: var(--spw-colors-support-grey-grey-900);
    text-transform: uppercase;
    @include breakpoint(lg) {
      padding: 12px 24px;
      display: block;
      text-transform: none;
      text-decoration: none !important;
    }
  }

  &--active {
    font-weight: bold;
    ::slotted(a) {
      @include under-breakpoint(lg) {
        color: var(--spw-ds-primary) !important;
        text-decoration: none !important;
      }
    }
  }
}
